import { z } from "zod";

const DailyResponseDataSchema = z.object({
    // Raw group key (ota_code / agent_id uuid / "direct") — pass back as
    // filter.source to agent-report-daily-detail to drill into this row.
    // Optional: absent until the backend adding it is deployed, in which case
    // the drill-down is simply unavailable (see AgentTableReport's click guard).
    source: z.string().optional(),
    name: z.string(),
    percentage: z.number(),
    total_booking: z.number(),
    nights: z.number(),
    avg_stay: z.string(),
    avg_earning: z.string(),
    total_earning: z.string(),
});

const DailyResponseTotalSchema = z.object({
    total_booking: z.number(),
    total_nights: z.number(),
    avg_stay: z.string(),
    avg_earning: z.string(),
    total_earning: z.string(),
});

export const DailyResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(DailyResponseDataSchema),
    total: DailyResponseTotalSchema,
});

export type DailyResponse = z.infer<typeof DailyResponseSchema>;
export type DailyResponseData = z.infer<typeof DailyResponseDataSchema>;
export type DailyResponseTotal = z.infer<typeof DailyResponseTotalSchema>;